import Container from './StashFolder.container';
import StashFolder from './StashFolder';

export default Container(StashFolder);
